<template>
    <div class="mx-2 pt-5 d-flex flex-wrap align-center">
        <slot name="extra-controls" :startDate="startDate" :endDate="endDate"></slot>
        <date-picker label="Fecha inicio" @dateSelected="onStartDateSelected" class="mx-2 my-1" />
        <date-picker label="Fecha fin" @dateSelected="onEndDateSelected" class="mx-2 my-1" />
        <v-btn color="primary" class="ml-auto" @click="autoFilter()" v-if="useButton">
            <v-icon left>mdi-magnify</v-icon>
            Filtrar
        </v-btn>
        <slot :startDate="startDate" :endDate="endDate"></slot>
    </div>
</template>

<script>
import DatePicker from '@/components/DatePicker'
import { convertDateFormat } from '@/helpers/formatDate'
import moment from 'moment';

export default {
    name: 'DateFilter',

    components: { DatePicker },

    props: {
        dataToFilter: {
            type: Array,
        },
        componentToFilter: {
            type: String,
            default: 'History'
        },
        filterEndpoint: {
            type: Function
        },
        isFilteredByOutsource: {
            type: Boolean
        },
        search:{
            type: Object,
            default: () => ({})
        },
        useButton:{
            type: Boolean,
            default: true,
        },
    },

    mounted() {
        this.saveData()
        // Emitir reset-data para cargar todas las facturas inicialmente
        this.$emit('reset-data')
    },

    data() {
        return {
            startDate: null,
            endDate: null,
            oldData: [],
            sourceFormat: "dd/mm/yyyy",
            targetFormat: "yyyy-mm-dd",
        }
    },

    methods: {
        onStartDateSelected(param) {
            this.startDate = param;
            this.$emit('setStartDate', param);
            if(!this.useButton)
                this.autoFilter();
        },
        
        onEndDateSelected(param) {
            this.endDate = param;
            this.$emit('setEndDate', param);
            if(!this.useButton)
                this.autoFilter();
        },

        async autoFilter() {
            // Solo filtrar si ambas fechas están seleccionadas
            if (this.startDate && this.endDate) {
                await this.filterData();
            }
        },

        async filterData() {
            await this.$nextTick();
            this.$emit('datesSelected', { start: this.startDate, end: this.endDate })
            this.setDateFormat()

            this.resetDateData()
            !this.isFilteredByOutsource
                ? this.filterByEndpoint()
                : this.filterByComponent()
        },
        
        resetFilter() {
            this.$emit('filtered-data', this.oldData)
            this.$emit('reset-data')
        },
        saveData() {
            if (this.dataToFilter && Array.isArray(this.dataToFilter)) {
                this.oldData = [...this.dataToFilter]
            }
        },
        setDateFormat() {
            return {
                 startDate: new Date(convertDateFormat(this.startDate, this.sourceFormat, this.targetFormat)),
                 endDate: new Date(convertDateFormat(this.endDate, this.sourceFormat, this.targetFormat)) 
            }
        },
        resetDateData() {
            if (this.oldData.length > 0 && this.dataToFilter) {
                this.dataToFilter = [...this.oldData]
            }
        },
        filterByComponent() {
            try {
                if( this.componentToFilter == 'HistoryR2' ) {
                    moment.locale( 'es_SV' );
                    
                    const filteredData =
                        [...this.dataToFilter].filter((data) => {
                            const dataDate = moment( data.InvoiceDate )
                            const startFormatted = moment( this.startDate, 'DD/MM/YYYY' )
                            const endFormatted = moment( this.endDate, 'DD/MM/YYYY' )
                            const isInRange = dataDate.isBetween( startFormatted, endFormatted, 'day', '[]' );
                            return isInRange
                        });
                    
                    this.$emit('filtered-data', { data: filteredData })
                } else if (this.componentToFilter == 'History') {
                    const filteredData =
                        [...this.dataToFilter].filter((data) => {
                            const dataDate = new Date(convertDateFormat(data.InvoiceDate, this.sourceFormat, this.targetFormat))
                            const isInRange = dataDate >= this.startDate && dataDate <= this.endDate
                            console.log( isInRange, dataDate );
                            return isInRange
                        })
                    this.$emit('filtered-data', filteredData)
                } else if (this.componentToFilter == 'PurchareOrdersList') {
                    const filteredData =
                        [...this.dataToFilter].filter((data) => {
                            const dataDate = new Date(convertDateFormat(data.PurchaseOrderDate, this.sourceFormat, this.targetFormat))
                            const isInRange = dataDate >= this.startDate && dataDate <= this.endDate
                            return isInRange
                        }
                    )
                    this.$emit('filtered-data', filteredData)
                }
            } catch (error) {
                console.log( error );
            }
        },
        async filterByEndpoint(){
            const { startDate, endDate } = this.setDateFormat()
            console.log('filtrando por endpoint');
            let result =[];
            try {
                this.$emit('filtered-loading', true)
                result = await this.filterEndpoint({ start: startDate, end: endDate, ...this.search});
            } catch (error) {
                console.error("DateFilter error:", error);
            }finally{
                this.$emit('filtered-loading', false)
            }
            this.$emit('filtered-data', result)
        }
    }
}
</script>

<style scoped>
.btn-add {
    background-color: #4690DB !important;
    color: white;
}

.btn-filter {
    background-color: #f29d35 !important;
    color: white;
}

.background {
    background: white !important;
    color: white;
}
</style>
